<template>
  <div class="form-wrapper">
    <div class="header-skeleton">
      <v-skeleton-loader
        type="heading"
        width="420"
      />
      <div class="subheading-skeleton">
        <v-skeleton-loader
          type="text"
          width="100%"
        />
        <v-skeleton-loader
          type="text"
          width="85%"
        />
      </div>
    </div>

    <div
      v-for="fieldIndex in 7"
      :key="fieldIndex"
      class="field-skeleton"
    >
      <v-skeleton-loader
        type="text"
        width="200"
        height="18"
        class="mb-2"
      />
      <v-skeleton-loader
        v-if="fieldIndex <= 4"
        type="text"
        height="48"
        width="100%"
      />
      <v-skeleton-loader
        v-else
        type="text"
        height="96"
        width="100%"
      />
    </div>

    <v-skeleton-loader
      type="button"
      width="120"
      height="40"
    />
  </div>
</template>

<style scoped lang="less">
.form-wrapper {
  border-radius: 10px;
  background: @white;
  padding: 28px 32px 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: flex-start;
  justify-content: flex-start;
  max-width: 720px;
  width: 100%;
}

.header-skeleton {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}

.subheading-skeleton {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  max-width: 560px;
}

.field-skeleton {
  width: 100%;
}
</style>
